import { fmtDate, inr, STATUS_LABEL } from "@/lib/api";
import { useMember } from "@/pages/Member";
import { Card } from "@/components/member/MemberOverview";

const Line = ({ left, right }) => <div className="flex flex-wrap justify-between gap-2 border-b border-slate-100 py-2 text-sm last:border-0"><span>{left}</span><span>{right}</span></div>;

export const MemberOrders = () => {
  const [o] = useMember("/mlm/me/orders");
  const [pays] = useMember("/mlm/me/payments");
  if (!o || !pays) return <p className="text-slate-500">Loading…</p>;
  return (
    <div className="space-y-6">
      <Card title="Package payment history" testid="member-payments">
        {pays.length ? pays.map((p) => <Line key={p.id} left={`${p.reference} · ${p.razorpay_payment_id || p.razorpay_order_id} · ${fmtDate(p.created_at)}`} right={`${inr(p.amount)} · ${STATUS_LABEL[p.status] || p.status}${p.receipt_no ? ` · ${p.receipt_no}` : ""}`} />) : <p className="text-sm text-slate-500">No payments yet.</p>}
      </Card>
      <Card title="Product order history (shop)" testid="member-shop-orders">
        {o.shop_orders.length ? o.shop_orders.map((s) => <Line key={s.order_number} left={`${s.order_number} · ${fmtDate(s.created_at)}`} right={`${inr(s.total)} · ${STATUS_LABEL[s.status] || s.status}`} />) : <p className="text-sm text-slate-500">No shop orders with your email.</p>}
      </Card>
      <Card title="Sales through your referral link" testid="member-referred-sales">
        {o.referred_sales.length ? o.referred_sales.map((s) => <Line key={s.order_number} left={`${s.order_number} · ${fmtDate(s.paid_at)}`} right={`${inr(s.total)} · ${STATUS_LABEL[s.status] || s.status}`} />) : <p className="text-sm text-slate-500">No verified sales yet.</p>}
      </Card>
    </div>
  );
};
